export default "__VITE_ASSET__BncUxYpt__"